module.exports = __webpack_public_path__ + "static/media/logo.1b686f91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 398
// module chunks = 0